import { defineStore } from 'pinia';

export const useOptionsStore = defineStore('options', {
    state: () => ({
        roles: [],
        statuses: [],
        provinces: [],
        twoFactorMethods: [],
        securityQuestionTemplates: [],
        securityCheckpoint: false,
        genders: [],
        assessmentStatuses: [],
        domains: [],
        assessmentDomains: [],
        assessmentTypes: [],
        subDomains: [],
        questionTypes: [],
        organizations: [],
        sports: [],
        assessments: [],
        memberProfiles: [],
        scaledOptions: [],
    }),
    actions: {
        reset() {
            this.$reset();
        },
    },
    getters: {
        roleOptions: (state) => {
            return state.roles;
        },

        provinceOptions: (state) => {
            return state.provinces.map((province) => ({
                label: province.name,
                value: province.id,
            }));
        },

        assessmentStatusesOptions: (state) => {
            return state.assessmentStatuses.map((status) => ({
                label: status.name,
                value: status.id,
            }));
        },

        assessmentDomainOptions: (state) => {
            return state.assessmentDomains.map((domain) => ({
                label: domain.name,
                value: domain.id,
            }));
        },

        assessmentTypeOptions: (state) => {
            return state.assessmentTypes.map((type) => ({
                label: type.name,
                value: type.id,
            }));
        },

        subDomainOptions: (state) => {
            return state.subDomains.map((subDomain) => ({
                label: subDomain.name,
                value: subDomain.id,
                domain_id: subDomain.domain_id,
            }));
        },

        questionTypeOptions: (state) => {
            return state.questionTypes.map((type) => ({
                label: type.name,
                value: type.id,
            }));
        },

        organizationsOptions: (state) => {
            return state.organizations.map((organization) => ({
                label: organization.name,
                value: organization.id,
            }));
        },

        sportsOptions: (state) => {
            return state.sports.map((sport) => ({
                label: sport.name,
                value: sport.id,
            }));
        },

        assessmentOptions: (state) => {
            return state.assessments;
        },

        memberProfilesOptions: (state) => {
            return state.memberProfiles.map((profile) => ({
                label: profile.sport.name + ' - ' + profile.organization.name,
                value: profile.id,
            }));
        },

        genderOptions: (state) => state.genders,
    }
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useOptionsStore.acceptHMRUpdate);
}
